import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  CalendarIcon,
  TicketIcon,
  ShoppingBagIcon,
  ExclamationTriangleIcon,
  UserCircleIcon,
  HomeIcon,
  TagIcon,
  BuildingOffice2Icon
} from '@heroicons/react/24/outline'
import {
  CalendarIcon as CalendarIconSolid,
  TicketIcon as TicketIconSolid,
  ShoppingBagIcon as ShoppingBagIconSolid,
  ExclamationTriangleIcon as ExclamationTriangleIconSolid,
  UserCircleIcon as UserCircleIconSolid,
  HomeIcon as HomeIconSolid,
  TagIcon as TagIconSolid,
  BuildingOffice2Icon as BuildingOffice2IconSolid
} from '@heroicons/react/24/solid'

const MobileBottomNav = () => {
  const location = useLocation()

  const menuItems = [
    { 
      id: 'home', 
      label: 'Home', 
      icon: HomeIcon,
      iconSolid: HomeIconSolid,
      path: '/account'
    },
    { 
      id: 'events', 
      label: 'Events', 
      icon: CalendarIcon,
      iconSolid: CalendarIconSolid,
      path: '/events'
    },
    { 
      id: 'offers', 
      label: 'Offers', 
      icon: TagIcon,
      iconSolid: TagIconSolid,
      path: '/offers'
    },
    { 
      id: 'centers', 
      label: 'Centers', 
      icon: BuildingOffice2Icon,
      iconSolid: BuildingOffice2IconSolid,
      path: '/centers'
    },
    { 
      id: 'tickets', 
      label: 'Tickets', 
      icon: TicketIcon,
      iconSolid: TicketIconSolid,
      path: '/account/tickets'
    },
    { 
      id: 'orders', 
      label: 'Orders', 
      icon: ShoppingBagIcon,
      iconSolid: ShoppingBagIconSolid,
      path: '/account/orders'
    },
    { 
      id: 'disputes', 
      label: 'Disputes', 
      icon: ExclamationTriangleIcon,
      iconSolid: ExclamationTriangleIconSolid,
      path: '/account/disputes'
    },
    { 
      id: 'profile', 
      label: 'Profile', 
      icon: UserCircleIcon,
      iconSolid: UserCircleIconSolid,
      path: '/account/profile'
    }
  ]

  // Determine active item based on current path
  const getActiveItem = () => {
    const currentPath = location.pathname
    if (currentPath === '/account' || currentPath === '/account/') {
      return 'home'
    }
    // Check for exact matches first
    const exactMatch = menuItems.find(item => currentPath === item.path)
    if (exactMatch) {
      return exactMatch.id
    }
    // Check for path starts with (for centers, check if path starts with /centers)
    if (currentPath.startsWith('/centers')) {
      return 'centers'
    }
    // Then check for other path starts with
    return menuItems.find(item => currentPath.startsWith(item.path))?.id || 'home'
  }

  const activeItemId = getActiveItem()

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 shadow-lg safe-area-inset-bottom">
      <div className="flex items-center justify-around h-16 sm:h-20 px-1 sm:px-2">
        {menuItems.map((item) => {
          const Icon = item.icon
          const IconSolid = item.iconSolid
          const isActive = activeItemId === item.id
          const ActiveIcon = isActive ? IconSolid : Icon
          
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`relative flex flex-col items-center justify-center flex-1 h-full min-h-[44px] px-1 sm:px-2 transition-all duration-200 ${
                isActive ? 'text-cyan-600' : 'text-slate-400'
              } active:scale-95`}
            >
              <ActiveIcon className={`w-6 h-6 sm:w-7 sm:h-7 transition-colors ${isActive ? 'text-cyan-600' : 'text-slate-400'}`} />
              {/* Show label on larger mobile screens */}
              <span className={`hidden sm:block text-[10px] sm:text-xs font-medium mt-0.5 ${isActive ? 'text-cyan-600' : 'text-slate-400'}`}>
                {item.label}
              </span>
              {isActive && (
                <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 rounded-full bg-cyan-600"></div>
              )}
            </Link>
          )
        })}
      </div>
    </nav>
  )
}

export default MobileBottomNav



